import {Injectable} from '@angular/core';
import {CrudService} from './crud.service';
import {Spring} from '../constants/spring';

@Injectable({
  providedIn: 'root'
})
export class ComboBoxService {

  constructor(private crud: CrudService,
              private spring: Spring) {
  }

  getListGlsocied() {
    return this.crud.get(`${this.spring.GLSOCIED_GET_LIST}`);
  }

  getListGlaccmov() {
    return this.crud.get(`${this.spring.GLACCMOV_GET_LIST}`);
  }

  getListPsterest() {
    return this.crud.get(`${this.spring.PSTEREST_GET_LIST}`);
  }

  getListGltipadjByAplicaAdherentes(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_ADHERENTES}${id}`);
  }

  loadComboGltipadjByFicorret(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_FICORRET}${id}`);
  }

  loadComboGltipadjByFimovimi(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_FIMOVIMI}${id}`);
  }

  loadComboGltipadjByFimovinv(id: number) {
    return this.crud.get(`${this.spring.GLTIPADJ_GET_LIST_FIMOVINV}${id}`);
  }

  getListGltipmon() {
    return this.crud.get(`${this.spring.GLTIPMON_GET_LIST}`);
  }

  getListFietapas(idfideic: any) {
    return this.crud.get(`${this.spring.FIETAPAS_GET_LIST}${idfideic}`);
  }

  getListFiavance() {
    return this.crud.get(`${this.spring.FIAVANCE_GET_LIST}`);
  }

  getListFiperinv() {
    return this.crud.get(`${this.spring.FIPERINV_GET_LIST}`);
  }

  getListFicorest(){
    return this.crud.get(`${this.spring.FICOREST_GET_LIST}`);
  }

  getListFitipmov() {
    return this.crud.get(`${this.spring.FITIPMOV_GET_LIST}`);
  }

  getListPstercerByIdfideic(idfideic: any) {
    return this.crud.get(`${this.spring.PSTERCER_GET_LIST_BY_IDFIDEIC}${idfideic}`);
  }

}
